import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router';
import { BasePage, PageType } from 'src/components/BasePage';
import { EntityPresentation } from 'src/components/EntityPresentation/EntityPresentation';
import { RequestsStore } from 'src/stores/RequestsStore/RequestsStore';
import styled from 'styled-components';

type RequestPageRouterParams = {
    requestId: string;
};

const store = RequestsStore;
export const RequestPage = observer(() => {
    const { params } = useRouteMatch<RequestPageRouterParams>();

    useEffect(() => {
        store.loadItem(params.requestId);
        store.loadForm();
        () => {
            store.itemLoader.reset();
            store.formLoader.reset();
        };
    }, [params.requestId]);

    const pageIsLoading =
        store.itemLoader.isLoading || store.formLoader.isLoading;

    return (
        <StyledRequestPageWrapper>
            <BasePage
                isLoading={pageIsLoading}
                type={PageType.BASE}
                pageName="request"
            >
                <EntityPresentation store={store} />
            </BasePage>
        </StyledRequestPageWrapper>
    );
});

const StyledRequestPageWrapper = styled.span`
    .header-panel {
        .row {
            justify-content: space-between;
            gap: 1rem;
        }
    }
`;
